import { IGetWithDraw } from "../../utils/types";
import { apiManager } from "../api-manager";

export const getwithdraw = async (withdrawalStatus?: string, page?: number) => {
  let res = await apiManager.get<IGetWithDraw>(
    "transactions/?type=withdrawal",
    {
      params: { withdrawalStatus, page },
    }
  );
  return res;
};
